import { execSQL, esc, num } from './api';

const TABLE = 'dbo.payroll_loan';
const SP    = 'dbo.payroll_loan_sp';

// The loan type says which payslip deduction line its installments belong on,
// so it travels with the loan rather than being guessed from the type's name.
export const fetchLoans = () =>
  execSQL(
    `SELECT l.*, lt.linkedComponent, lt.installmentMethod ` +
    `FROM ${TABLE} l ` +
    `LEFT JOIN dbo.payroll_loan_type lt ON lt.id = l.loanTypeId ` +
    `ORDER BY l.id DESC`
  );

export const createLoan = (d) =>
  execSQL(
    `EXEC ${SP} @action='INSERT',@emp_id=${esc(d.emp_id)},@loanTypeId=${num(d.loanTypeId)},` +
    `@loanType=${esc(d.loanType)},@principal=${num(d.principal)},@interestRate=${num(d.interestRate)},` +
    `@totalPayable=${num(d.totalPayable)},@installments=${num(d.installments)},` +
    `@monthlyInstallment=${num(d.monthlyInstallment)},@remaining=${num(d.totalPayable)},` +
    `@startDate=${esc(d.startDate)}`
  );

// Editing a live loan: the employee is fixed (change that and it is a different
// loan), but every figure can move - a resignation settles the balance early.
export const updateLoan = (id, d) =>
  execSQL(
    `EXEC ${SP} @action='UPDATE',@id=${num(id)},@loanTypeId=${num(d.loanTypeId)},` +
    `@loanType=${esc(d.loanType)},@principal=${num(d.principal)},@interestRate=${num(d.interestRate)},` +
    `@totalPayable=${num(d.totalPayable)},@installments=${num(d.installments)},` +
    `@monthlyInstallment=${num(d.monthlyInstallment)},@remaining=${num(d.remaining)},` +
    `@startDate=${esc(d.startDate)}`
  );

export const closeLoan = (id) =>
  execSQL(`EXEC ${SP} @action='CLOSE',@id=${id}`);
